import styled from "styled-components";

export const MoviesWrapper = styled.div``;

export const MovieWrapper = styled.div`
  padding: 0px 8px;
  line-height: 25px;
`;

export const WrapperImg = styled.div``;

export const WrapperTitle = styled.span`
  font-weight: bold;
  cursor: pointer;
`;

export const MoviesContainer = styled.div``;

export const ReleaseDate = styled.div`
  justify-content: space-between;
  display: flex;
  padding-right: 20px;
`;

export const MovieImg = styled.img`
  border-radius: 10px;
  border-style: none;
  width: 300px;
  height: 420px;
  cursor: pointer;
`;
